import React, {useContext} from 'react';

import ApplicationButton from "./ApplicationButton";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {WMSRoutes} from "utils/WMSRoutes";
import {APPLICATIONS as Apps} from "utils/Applications";


import StripeItem from "./ApplicationItems/StripeItem";
import OMSItem from "./ApplicationItems/OMSItem";
import EikowItem from "./ApplicationItems/EikowItem";

import {SidebarContext} from "../../../../../SidebarContext";

function ApplicationList(props) {
    const {
        selectedApplication,
        organizationApplications,
        isMobile
    } = useContext(SidebarContext);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '200px',
        }}>
            {(organizationApplications[Apps.getBackendName(Apps.MARKETPLACE)] || organizationApplications[Apps.getBackendName(Apps.STATISTICS)]) && (
                <ApplicationButton
                    to={MarketplaceRoutes.ROOT}
                    application={Apps.MARKETPLACE}
                    selected={selectedApplication === Apps.MARKETPLACE}
                />
            )}
            {organizationApplications[Apps.getBackendName(Apps.OMS)] && (
                <OMSItem />
            )}
            {organizationApplications[Apps.getBackendName(Apps.WMS)] && (
                <ApplicationButton
                    to={WMSRoutes.DASHBOARD}
                    application={Apps.WMS}
                    selected={selectedApplication === Apps.WMS}
                />
            )}
            <EikowItem />
            <StripeItem />
        </div>
    );
}

export default ApplicationList;
